import officeMarker from "../assets/office-marker.svg";
import officeMarkerOpened from "../assets/office-marker-opened.svg";
import offieRating from "../assets/offierating.png";

export default office => {
  return `
  <div class="office-overlay" data-id="${office.id}">
    <img class="office-marker" src="${officeMarker}">
    <img class="office-opened-marker" src="${officeMarkerOpened}">
    <div class="office-infowindow">
      <div class="flex">
        <img class="office-infowindow__picture" src="${process.env
          .VUE_APP_API_URL + office.mainImage?.url}">
        <div class="flex flex-col w-full">
          <div class="p-2">
            <h3>${office.name}</h3>
            <p>${office.postalCode} ${office.city},<br>${office.addressLine}</p>
          </div>
          <div class="office-infowindow__offie-rating mt-auto">
            <span class="!flex">
              <img src="${offieRating}">
              <div>${office.offieRating ? office.offieRating : "-"}</div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
`;
};
